module.exports = __webpack_public_path__ + "img/topicimg.3547cf90.png";